import { render, staticRenderFns } from "./AccountUsernameComponent.vue?vue&type=template&id=94b5f1e8&scoped=true&"
import script from "./AccountUsernameComponent.vue?vue&type=script&lang=ts&"
export * from "./AccountUsernameComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AccountUsernameComponent.vue?vue&type=style&index=0&id=94b5f1e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b5f1e8",
  null
  
)

export default component.exports